<template>
  <div class="coupon-container " v-login>
    <commonHeader></commonHeader>
    <div class="coupon-item-container" v-if="couponList.length">
      <div class="obtain-tip">领取优惠券</div>
      <div v-for="item in couponList" :key="item.id">
        <div
          class="coupon-item-coupon"
          :class="{ disabled: !item.can_obtain }"
          @click="obtainCoupon(item)"
        >
          <div class="coupon-title">
            {{ item.used_scope === 'all' ? '通用券' : '商品券' }}:
            {{ item.activity_name }}
          </div>
          <div class="coupon-price">¥ {{ item.discount_price.toFixed(2) }}</div>
          <div class="coupon-condition">
            {{
              item.threshold_price
                ? `满¥${item.threshold_price}可用`
                : `无门槛使用`
            }}
          </div>
          <div class="obtain-time">
            有效日期: {{ item | effectiveTimeText }}
          </div>
          <!-- <div class="small-tip">
          * 点击领取
        </div> -->
        </div>
        <div class="coupon-btn-container">
          <button
            class="btn-g"
            v-if="
              ((+item.per_count === 1 && +item.collected_num === 0) ||
                +item.per_count > 1) &&
                item.can_obtain
            "
            @click="obtainCoupon(item)"
          >
            {{ buttonText }}
          </button>
          <div v-if="+item.collected_num > 0">
            <button
              class="btn-g"
              @click="useCoupon(item)"
              :class="{ disabled: !item.can_use }"
            >
              去使用
            </button>
            <p class="my-coupon" @click="toMyCoupon()">我的优惠券</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import noData from '../comps/noData'
import * as util from '../../util'
import { isWeixin } from '@ivy/fts/utils'
import showBindPhone from '@ivy/fts/showBindPhone'
import commonHeader from '../common/commonHeader'
import { env } from '@ivy/fts/envInfo/envInfo'
import config from '../../config/index'

export default {
  data() {
    return {
      couponList: [],
      isWeixin: isWeixin(),
      buttonText: '点击领取',
    }
  },
  components: {
    commonHeader,
  },
  filters: {
    effectiveTimeText(coupon) {
      return {
        fixed: `${coupon.used_start_time}至${coupon.used_end_time}`,
        relative: `自领券时${coupon.valid_day}日内有效`,
        month: '领取当月有效',
        same_day: '仅领取当天有效',
      }[coupon.used_time_type]
    },
  },
  methods: {
    async obtainCoupon(coupon) {
      const { sellerId } = this.$route.query
      await env.init()
      if (!(await env.getIsLogin())) {
        return await env.login()
      }

      // if (!this.$store.logined.token) {
      //   // 用户尚未注册
      //   let logined = await showBindPhone(this.$store.bindPhoneConfig)
      //   if (!logined || !logined.token) return
      // }
      // if (!coupon.can_obtain) return
      // if (+coupon.per_count <= +coupon.collected_num) return this.$Toast(`已达到领取上限`)
      const { data } = await axios.post(`/api/goods/shop/search/coupon/acquireCoupon`, {
        couponId: coupon.id,
        activityId: coupon.activity_id,
        sellerId,
      })
      if (data.code) {
      return this.$Toast(data.message)
      }
      this.$Toast('领取成功啦')
      let { data: acquireCouponAfter } = await axios.get(
        `/api/mobile/knowlege/marketing/getCoupon`,
        {
          params: { couponId: this.couponId },
        }
      )
      if (
        this.isWeixin &&
        sellerId &&
        this.canUse(acquireCouponAfter) &&
        +acquireCouponAfter.collected_num > 0
      ) {
        await this.useCoupon(acquireCouponAfter)
        return
      }
      this.couponList = [acquireCouponAfter]
    },
    async getCouponList() {
      let { data } = await axios.get(
        `/api/mobile/knowlege/marketing/getCoupon`,
        {
          params: { couponId: this.couponId },
        }
      )
      this.couponList = [data]
    },
    async toMyCoupon() {
      window.location.href = `//${
        window.location.host
      }/center/coupon/couponList`
    },
    async useCoupon(item) {
      const { sellerId } = this.$route.query
      if (!item.can_use) return
      const courses = item.course
      if (courses && courses.length === 1) {
        const course = courses[0]
        if (course.course_type === 'knowlege') {
          return this.$router.push({
            path: 'channelDetail',
            query: {
              id: course.course_id,
            },
          })
        } else {
          window.location.href = `//${
            window.location.host
          }/center/purchase?course_id=${course.course_id}`
        }
      } else {
        let { data } = await this.$axios.get(
          `/api/goods/shop/search/coupon/queryCouponGoods`,
          {
            params: {
              couponId: item.id,
              offset: 0,
              limit: 10,
            },
          }
        )
        if (data && data.length === 1) {
          let data0 = data[0]
          let goodsUrl = `${window.location.origin}/goods/goodsView?spuId=${
            data0.goods.id
          }&type=${data0.goods_type}&couponId=${
            this.couponId
          }&sellerId=${sellerId}`

          if (env.type === 'ivydad') {
            await env.init()
            goodsUrl += '&navBarHide=1'
            await env.commonJump(
              `ivydadreadtool://h5?url=${encodeURIComponent(goodsUrl)}`
            )
          } else {
            window.location.href = goodsUrl
          }
          return
        }
        window.location.href = `//${
          window.location.host
        }/center/coupon/consumedCouponCourseList?couponId=${
          item.id
        }&sellerId=${sellerId}`
      }
    },
    canUse(coupon) {
      if (coupon.can_use) {
        return true
      }
      let now = new Date().getTime() + 1000 // + 1s
      // 兼容ios时间
      let begin = new Date(
        (coupon.used_start_time || '').replace(/\-/g, '/')
      ).getTime()
      let end = new Date(
        (coupon.used_end_time || '').replace(/\-/g, '/')
      ).getTime()
      return begin < now && now < end
    },
  },
  async created() {
    await env.init()
    // await this.$store.login(0, false)
    let { couponId, sellerId } = this.$route.query
    if (!couponId) return
    this.couponId = couponId
    await this.getCouponList()
    let coupon = this.couponList[0]
    this.buttonText =
      (this.isWeixin && sellerId && this.canUse(coupon) && '领取并使用') ||
      '点击领取'
  },
}
</script>
<style lang="less">
@import url('../../common.less');
.coupon-container {
  width: 100vw;
  .coupon-item-container {
    height: auto;
    .obtain-tip {
      padding: 1.3rem 0.88rem 0.88rem;
      font-size: 0.88rem;
      color: @commonColor;
    }
    .coupon-item-coupon {
      position: relative;
      height: 8.71rem;
      margin: 0 0.88rem 0 0.88rem;
      background-image: linear-gradient(0deg, #ffa0a5 0%, #fa6e78 100%);
      padding: 0.88rem;
      color: #fff;
      border-radius: 0.59rem;
      div {
        text-align: center;
      }
      .coupon-title {
        height: 1.18rem;
        font-size: 0.82rem;
        text-align: left;
      }
      .coupon-price {
        font-size: 2.35rem;
      }
      .coupon-condition {
        font-size: 1.06rem;
      }
      .obtain-time {
        margin-top: 0.59rem;
        font-size: 0.71rem;
      }
      .small-tip {
        text-align: left;
        font-size: 0.47rem;
      }
    }
    .coupon-btn-container {
      margin: 0.88rem;
      .display-flex;
      flex-direction: column;
      // background: #fbf5f5;
      // border: 1px double #e6e6e6;
      // border-radius: 0 0 .59rem .59rem;
      .btn-g {
        text-align: center;
        font-size: 0.88rem;
        color: #ffffff;
        padding: 0.25rem 0;
        width: 8.82rem;
        border-radius: 2rem;
        margin-top: 0.88rem;
        zoom: 1.5;
      }
      .my-coupon {
        text-align: center;
        margin-top: 1.47rem;
        height: 1.76rem;
        line-height: 1.76rem;
        font-size: 0.82rem;
        color: @commonColor;
      }
    }
  }
}
</style>
